import { cn } from '@/shared/lib/cn';

export interface SkeletonProps {
  /** `text` — pasek tekstu, `circle` — awatar, `block` — dowolny prostokat. */
  shape?: 'text' | 'circle' | 'block';
  className?: string;
}

/**
 * Zastepczy ksztalt na czas ladowania danych.
 *
 * Oznaczony jako `aria-hidden`, bo dla czytnikow ekranu liczy sie komunikat
 * o ladowaniu, a nie migoczace prostokaty.
 */
export function Skeleton({ shape = 'block', className }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'bg-surface-sunken animate-pulse',
        shape === 'text' && 'h-4 rounded-md',
        shape === 'circle' && 'aspect-square rounded-full',
        shape === 'block' && 'rounded-xl',
        className,
      )}
    />
  );
}

export interface SkeletonTextProps {
  /** Liczba wierszy. Ostatni jest krotszy, jak w prawdziwym akapicie. */
  lines?: number;
  className?: string;
}

/** Kilka wierszy tekstu zastepczego. */
export function SkeletonText({ lines = 3, className }: SkeletonTextProps) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton
          key={index}
          shape="text"
          className={index === lines - 1 ? 'w-3/5' : 'w-full'}
        />
      ))}
    </div>
  );
}
